module.exports = __webpack_public_path__ + "static/media/md-ice-cream.3f2b94c3.svg";